import { useSelector } from 'react-redux'
import { dispatch } from 'store'
import { aiAvatarSelectors } from 'store/features/aiAvatar/selectors'
import { aiAvatarThunks } from 'store/features/aiAvatar/thunks'
import { T } from 'consts/translationKeys'
import { translate } from 'utils/translations'
import AvatarActionButton from '../action-btn/AvatarActionButton'
import * as Styled from './styled'

// One-step undo of the last Enhance/Resize replacement. Visible only while the
// `previousSourceImage` snapshot exists — clicking restores it (image + ratio)
// and the snapshot is dropped, so the button removes itself. No API call, no
// credits: it's a pure form-state revert.
const UndoSourceImageButton = () => {
  const hasPreviousSourceImage = useSelector(
    aiAvatarSelectors.hasPreviousSourceImage
  )

  if (!hasPreviousSourceImage) return null

  return (
    <Styled.UndoSlot>
      <AvatarActionButton
        icon={<Styled.UndoIcon />}
        tooltipText={translate(T.UNDO)}
        onClick={() => dispatch(aiAvatarThunks.undoSourceImageChange())}
        testId="avatar-preview-undo"
      />
    </Styled.UndoSlot>
  )
}

export default UndoSourceImageButton
